/**
 *
 * FilterClubs
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { compose } from 'redux';
import { FormControl, ListGroup, ListGroupItem } from 'react-bootstrap';
import { injectIntl, intlShape } from 'react-intl';
import withRoute from 'containers/withRoute';
import withClubs from 'containers/Clubs/withEntity';
import CloseButton from 'components/CloseButton';
import memoize from 'memoize-one';
import { listFromId } from 'utils/arrays';
import messages from './messages';

const MINLENGTH = 3;

const listClubs = memoize(listFromId);

const Wrapper = styled.div`
  position: relative;
  margin-bottom: 5px;
  input {
    margin-top: 15px;
  }
  button.close {
    position: absolute;
    top: 6px;
    right: 6px;
  }
  .list-group.list-group.list-group {
    position: absolute;
    margin: 0;
    left: 0;
    right: 0;
    max-height: 200px;
    overflow-y: auto;
    z-index: 1100;
  }
  .list-group-item {
    padding: 5px 15px;
    font-size: 1.2rem;
  }
`;

class FilterClubs extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { filter: '', loaded: false };
    this.handleChange = this.handleChange.bind(this);
    this.reset = this.reset.bind(this);
  }

  handleChange(ev) {
    const { apiList } = this.props;
    const { loaded } = this.state;
    if (!loaded) {
      apiList();
    }
    this.setState({ filter: ev.target.value, loaded: true });
  }

  reset() {
    this.setState({ filter: '' });
    document.getElementById('filter-clubs').focus();
  }

  filteredClubs() {
    const { clubs } = this.props;
    const { filter } = this.state;
    if (clubs.loading || !clubs.list || filter.length < MINLENGTH) {
      return null;
    }
    const list = listClubs(clubs, 'list');
    const lcFilter = filter.toLowerCase();
    const test = item =>
      [item.name, item.city].some(
        str => str && str.toLowerCase().includes(lcFilter),
      );
    const result = list.filter(test);
    return result;
  }

  render() {
    const { clickTo, intl, className } = this.props;
    const { filter } = this.state;
    const list = this.filteredClubs();
    return (
      <Wrapper className={className}>
        <FormControl
          type="text"
          id="filter-clubs"
          name="filterClubs"
          placeholder={intl.formatMessage(messages.nameOrCity)}
          value={filter}
          onChange={this.handleChange}
          aria-label="Text to filter clubs"
        />
        {filter.length > 0 && (
          <CloseButton onClose={this.reset} message={messages.reset} />
        )}
        {list && (
          <ListGroup>
            {list.map(item => (
              <ListGroupItem
                key={item.id}
                onClick={clickTo(`/club/${item.id}`)}
              >
                {item.name}, {item.city}
              </ListGroupItem>
            ))}
          </ListGroup>
        )}
      </Wrapper>
    );
  }
}

FilterClubs.propTypes = {
  className: PropTypes.string,
  clubs: PropTypes.object.isRequired,
  apiList: PropTypes.func.isRequired,
  clickTo: PropTypes.func.isRequired,
  intl: intlShape,
};

export default compose(
  withClubs,
  withRoute,
  injectIntl,
)(FilterClubs);
